module.exports = __webpack_public_path__ + "static/media/Suren Subbiah.e8ae2305.png";